export default function ValueAdjacency(polyMap) {

  this.polyMap = polyMap;

  this._compute();

};

ValueAdjacency.prototype = {

  constructor: ValueAdjacency,

  // V -> E, part 1
  getNumEdgesForVertex: function (valueIndex) {
    const valueBegin = this.valueEdgeOffsets[valueIndex];
    const valueUntil = this.valueEdgeOffsets[valueIndex + 1];
    const numValueEdges = valueUntil - valueBegin;

    return numValueEdges;
  },

  // V -> E, part 2
  getEdgeForVertexId: function (valueIndex, edgeOffset) {
    const valueBegin = this.valueEdgeOffsets[valueIndex];
    return this.valueEdgeIndices[valueBegin + edgeOffset];
  },

  //V->VV returns the adjacent values to a given vertex
  getAdjacentValues: function (valueIndex) {
    const edgeVertexAdjacency = this.polyMap.edgeVertexAdjacency;
    const adjacentValues = [];
    const numEdges = this.getNumEdgesForVertex(valueIndex);

    for (let i = 0; i < numEdges; i++) {
      const edge = this.getEdgeForVertexId(valueIndex, i);
      const values = edgeVertexAdjacency.getVerticesForEdge(edge);
      const adjacentValue = (values.v === valueIndex) ? values.vNext : values.v;
      adjacentValues.push(adjacentValue);
    }

    return adjacentValues;
  },

  //V->VV for a given faceValueIndex and face, returns the (0-2) adjacent faceValueIndices on that face
  getAdjacentFaceValuesIndicesOnFace: function (faceValueIndex, face) {

    const adjacentValuesOnFace = [];
    const faceBegin = this.polyMap.faceRangeOffsets[face];
    const faceEnd = this.polyMap.faceRangeOffsets[face + 1];
    const faceSize = faceEnd - faceBegin;
    if (faceSize < 3) return adjacentValuesOnFace;

    const next = (faceValueIndex === faceEnd - 1) ? faceBegin : faceValueIndex + 1;
    const prev = (faceValueIndex === faceBegin) ? faceEnd - 1 : faceValueIndex - 1;

    adjacentValuesOnFace.push(prev);
    adjacentValuesOnFace.push(next);

    return adjacentValuesOnFace;
  },

  // V -> F, part 1
  getNumFacesForVertex: function (faceValueIndex) {
    const valueBegin = this.valueFaceOffsets[faceValueIndex];
    const valueUntil = this.valueFaceOffsets[faceValueIndex + 1];
    const numValueFace = valueUntil - valueBegin;

    return numValueFace;
  },

  // V -> F, part 2
  getFaceForVertexId: function (faceValueIndex, faceOffset) {
    const valueBegin = this.valueFaceOffsets[faceValueIndex];
    return this.valueFaceIndices[valueBegin + faceOffset];
  },

  _compute: function () {

    const polyMap = this.polyMap;

    const faceRangeOffsets = polyMap.faceRangeOffsets;
    const faceValueIndices = polyMap.faceValueIndices;

    const edgeVertexAdjacency = polyMap.edgeVertexAdjacency;

    const valueFaceCount = new Uint32Array(polyMap.values.length);
    const valueEdgeCount = new Uint32Array(polyMap.values.length);
    //const numFaces = faceRangeOffsets.length - 1;

    const numEdges = edgeVertexAdjacency.getNumEdges();
    const edgeUnique = new Uint8Array(numEdges);

    // histogram.
    for (let f = 0; f < polyMap.faceRangeOffsets.length - 1; f++) {

      const faceBegin = polyMap.faceRangeOffsets[f];
      const faceUntil = polyMap.faceRangeOffsets[f + 1];
      const numFaceValues = faceUntil - faceBegin;

      let vNext = polyMap.faceValueIndices[faceBegin];

      for (let fv = 0; fv < numFaceValues; fv++) {

        const v = vNext;
        vNext = polyMap.faceValueIndices[faceBegin + ((fv + 1) % numFaceValues)];

        const e = edgeVertexAdjacency.findEdgeId(v, vNext);

        valueFaceCount[v]++;

        // is this the first time processing this edge
        if (edgeUnique[e] === 0) {
          edgeUnique[e] = 1;

          valueEdgeCount[v]++;
          valueEdgeCount[vNext]++;
        }
      }
    }

    // create offset arrays.
    let faceSum = 0, edgeSum = 0;
    const valueFaceOffsets = new Uint32Array(valueFaceCount.length + 1);
    const valueEdgeOffsets = new Uint32Array(valueEdgeCount.length + 1);
    for (let i = 0; i < valueFaceCount.length; i++) {
      valueFaceOffsets[i] = faceSum;
      faceSum += valueFaceCount[i];
      valueFaceCount[i] = 0;

      valueEdgeOffsets[i] = edgeSum;
      edgeSum += valueEdgeCount[i];
      valueEdgeCount[i] = 0;
    }

    valueFaceOffsets[valueFaceCount.length] = faceSum;
    valueEdgeOffsets[valueEdgeCount.length] = edgeSum;

    // fill in the values
    const valueFaceIndices = new Uint32Array(faceSum);
    const valueEdgeIndices = new Uint32Array(edgeSum);

    for (let f = 0; f < polyMap.faceRangeOffsets.length - 1; f++) {

      const faceBegin = polyMap.faceRangeOffsets[f];
      const faceUntil = polyMap.faceRangeOffsets[f + 1];
      const numFaceValues = faceUntil - faceBegin;

      let vNext = polyMap.faceValueIndices[faceBegin];

      for (let fv = 0; fv < numFaceValues; fv++) {

        const v = vNext;
        vNext = polyMap.faceValueIndices[faceBegin + ((fv + 1) % numFaceValues)];

        const e = edgeVertexAdjacency.findEdgeId(v, vNext);

        valueFaceIndices[valueFaceOffsets[v] + (valueFaceCount[v]++)] = f;

        // is this the first time processing this edge
        if (edgeUnique[e] === 1) {
          edgeUnique[e] = 2;

          valueEdgeIndices[valueEdgeOffsets[v] + (valueEdgeCount[v]++)] = e;
          valueEdgeIndices[valueEdgeOffsets[vNext] + (valueEdgeCount[vNext]++)] = e;
        }
      }
    }

    this.valueFaceOffsets = valueFaceOffsets;
    this.valueFaceIndices = valueFaceIndices;

    this.valueEdgeOffsets = valueEdgeOffsets;
    this.valueEdgeIndices = valueEdgeIndices;

  },
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/model/adjacency/ValueAdjacency.js